import { VaultTransaction } from '../../../../api/DynaVaultsAPI';

export const getDepositInfo = (transaction: VaultTransaction) => {
  return {
    token: transaction.metadata.deposit_token,
    amount: transaction.metadata.deposit_token_amount,
    shares: transaction.metadata.minted_shares,
  };
};

export const getWithdrawInfo = (transaction: VaultTransaction) => {
  return {
    token: transaction.metadata.withdrawal_token,
    amount: transaction.metadata.withdrawal_token_amount,
    shares: transaction.metadata.burned_shares,
  };
};

export const getSwapInfo = (transaction: VaultTransaction) => {
  return {
    token: transaction.metadata.token_in,
    amount: transaction.metadata.amount_in,
    shares: '-',
  };
};

export const getTransactionMetadata = (transaction: VaultTransaction) => {
  if (transaction.metadata.deposit_token) {
    return getDepositInfo(transaction);
  }

  if (transaction.metadata.withdrawal_token) {
    return getWithdrawInfo(transaction);
  }

  if (transaction.metadata.amount_in) {
    return getSwapInfo(transaction);
  }

  return null;
};
